import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Input,
  DatePicker,
  Card,
  Avatar,
  List,
  Collapse,
  Typography,
  Button,
  message,
  Row,
  Col,
} from 'antd';
import { CopyOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { fetchUsersById } from '../profile/api';
import { addRequest } from '../requests/api';
import { getDateFromTimestamp, copyText } from '../utils';
import PlayersList from '../components/PlayersList';
import TeamList from '../components/TeamList';

const { Paragraph, Title } = Typography;

function ShareModal({ shift, open, onClose }) {
  const store = useContext(StoreContext);
  const { formatMessage } = useIntl();
  const {
    user: [user, setUser, setUpdateUser],
    allRequests: [allRequests],
  } = store;

  const { Panel } = Collapse;
  const { price, players } = shift;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = async values => {
    onClose();
  };
  const onFinishFailed = values => {};

  const handleShareWithFriendsList = friendsListName => {
    const teamPlayers =
      user.friendsList.find(t => t.friendsListName === friendsListName)
        ?.players || [];

    const ids = teamPlayers.map(p => p.id);
    if (ids.length > 0) {
      fetchUsersById(ids, setLoading).then(users => {
        users.forEach(p => {
          addRequest(
            {
              shiftId: shift.id,
              photoURL: user.photoURL,
              from: user.nickname,
              to: p.email,
              startDate: getDateFromTimestamp(shift.startDate),
              placeName: shift.placeName,
              messageToken: p.messageToken,
              title: `Nuevo Partido en ${shift.placeName}`,
              url: `https://www.gamebooking.top/shifts?${shift.id}`,
              isNew: true,
            },
            setLoading,
          );
        });
      });
    }
  };

  return (
    <Modal
      title={
        <Row align="middle">
          <Col>
            <Title level={5}>
              {formatMessage({
                id: 'share.title',
              })}
            </Title>
          </Col>
          <Col offset={1}>
            <Button
              type="primary"
              shape="circle"
              loading={loading}
              icon={<CopyOutlined />}
              onClick={() =>
                copyText(
                  `Hola!! El partido organizado por *${
                    shift.organizerName
                  }* es el *${getDateFromTimestamp(
                    shift.startDate,
                  )}*\nDireccion: *https://www.google.com/maps/dir//${shift.address.replace(
                    / /g,
                    '%20',
                  )}*\nPrecio: *${shift.price}€*\n${
                    shift.description
                  }\nPara detalles y novedades ingresa a gamebooking.top/shifts?${
                    shift.id
                  }`,
                  message,
                )
              }
            />
          </Col>
        </Row>
      }
      open={open}
      onOk={onClose}
      onCancel={onClose}>
      <PlayersList
        header={formatMessage({
          id: 'player.props.friends',
        })}
        shift={shift}
        dataSource={user.friends.filter(
          f =>
            !shift.players.find(p => p.userId === f.uid) &&
            !shift.playRequests.find(p => p.userId === f.uid),
        )}
        share
      />
      <TeamList
        header={formatMessage({ id: 'player.props.teams' })}
        dataSource={user.friendsList}
        handleShareWithFriendsList={handleShareWithFriendsList}
      />
    </Modal>
  );
}

export default ShareModal;
